module.exports = __webpack_public_path__ + "static/media/platinum_badge.47aee788.png";